<script setup lang="ts">
import Navbar from './components/Navbar/index.vue'
import Siderbar from './components/SiderBar/index.vue'
import { useRoute } from 'vue-router'
import { storeToRefs } from 'pinia'
import { useMicroAppStore } from '@/store/modules/microApp'

const route = useRoute()

// pinia使用
const microAppStore = useMicroAppStore()
const { isMicroApp } = storeToRefs(microAppStore)
</script>

<template>
  <div class="wrapper flex column">
    <!-- 顶部导航 -->
    <Navbar v-if="route.name !== 'Download' && route.name !== 'Question'" />
    <div class="container col-grow flex row">
      <!-- 左侧菜单 -->
      <Siderbar
        v-if="
          route.name !== 'Download' &&
          route.name !== 'Question' &&
          route.name !== 'MiddlePage'
        "
      />
      <!-- 主体页面 -->
      <div
        :class="[
          route.name !== 'Download' && route.name !== 'Question'
            ? 'content'
            : 'content no-siderbar'
        ]"
      >
        <router-view />
        <!-- 微应用容器 -->
        <div
          id="micro-app-containter"
          :class="isMicroApp ? 'micro-app-height' : ''"
        ></div>
      </div>
    </div>
  </div>
</template>

<style lang="scss" scoped>
#micro-app-containter,
::v-deep #__qiankun_microapp_wrapper_for_micro_app__ {
  width: 100%;
  #app {
    width: 100%;
  }
}
.micro-app-height {
  height: 100%;
  ::v-deep #__qiankun_microapp_wrapper_for_micro_app__ {
    height: 100%;
    #app {
      height: 100%;
    }
  }
}
.wrapper {
  width: 100%;
  height: 100%;
  .container {
    overflow-y: auto;
    background-color: #edf0f5;
    .content {
      height: 100%;
      padding: 90px 20px 20px 220px;
      box-sizing: border-box;
      flex: 1;
      width: 0;
      position: relative;
      &.no-siderbar {
        padding: 0;
      }
    }
  }
}
</style>
